var React = require('react');

function Upload (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M4.163.819C4 1.139 4 1.559 4 2.4V9H2.803c-.883 0-1.325 0-1.534.176a.75.75 0 0 0-.266.62c.017.274.322.593.931 1.232l4.198 4.401c.302.318.453.476.63.535a.748.748 0 0 0 .476 0c.177-.059.328-.217.63-.535l4.198-4.4c.61-.64.914-.96.93-1.233a.75.75 0 0 0-.265-.62C12.522 9 12.081 9 11.197 9H10V2.4c0-.84 0-1.26-.164-1.581a1.5 1.5 0 0 0-.655-.656C8.861 0 8.441 0 7.6 0H6.4c-.84 0-1.26 0-1.581.163a1.5 1.5 0 0 0-.656.656zM0 19a1 1 0 0 0 1 1h12a1 1 0 0 0 0-2H1a1 1 0 0 0-1 1z","fill":"#919CB5"}));
}

Upload.defaultProps = {"width":"14","height":"20","fill":"none"};

module.exports = Upload;

Upload.default = Upload;
